import React from "react";
import { Box, Typography, useTheme, Tooltip, Avatar } from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { stringAvatar } from "../../../../config/AvatarColor";
import { formatChatTime } from "../../../../utils/timestampUtils";

// Renders one row for the Dashboard's TeamMembersPanel. `member` is the shape
// getTeamMembersPanel.service.js returns per row — no avatar image comes from the
// API (TeamMember has no such field), so this uses the same initials-avatar
// convention as ContactRow.jsx instead of an <img>.
function TeamMemberRow({ member, isLast }) {
  const theme = useTheme();
  const avatarProps = stringAvatar(member.name, 43);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.6,
        py: 1.7,
        borderBottom: !isLast ? `1px solid ${theme.palette.divider}` : "none",
      }}
    >
      <Box sx={{ position: "relative", flexShrink: 0 }}>
        <Avatar sx={{ ...avatarProps.sx, border: (t) => `1px solid ${t.palette.divider}` }}>
          {avatarProps.children}
        </Avatar>
        <Tooltip title={member.presence === "online" ? "Online" : "Away"}>
          <Box
            sx={{
              position: "absolute",
              bottom: "1px",
              right: "1px",
              width: "0.625rem",
              height: "0.625rem",
              borderRadius: "50%",
              backgroundColor: member.presence === "online" ? "#22c55e" : "#f59e0b",
              border: (t) => `1px solid ${t.palette.background.default}`,
            }}
          />
        </Tooltip>
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography sx={{ fontSize: "0.9375rem", fontWeight: 500 }}>{member.name}</Typography>
        <Typography sx={{ fontSize: "0.9375rem", color: "text.secondary", mt: 0.25, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
          {member.teamName || `Assigned to ${member.assignedCount} contacts`}
        </Typography>
      </Box>
      <Box sx={{ textAlign: "right", flexShrink: 0 }}>
        {member.since && (
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 0.4 }}>
            <AccessTimeIcon sx={{ fontSize: 13, color: "text.secondary" }} />
            <Typography sx={{ fontSize: "0.8125rem", lineHeight: 1, color: "text.secondary" }}>
              {`Since ${formatChatTime(member.since)}`}
            </Typography>
          </Box>
        )}
        <Typography sx={{ mt: 0.375, fontSize: "0.8125rem", fontWeight: 600, color: "text.primary" }}>
          {member.assignedCount} assigned
        </Typography>
      </Box>
    </Box>
  );
}

export default TeamMemberRow;
